import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import Search from "../../components/assets/Search";
import Link from "next/link";

export default function Nav({
  categories,
  onCategoryClick,
  onAllBlogsClick,
  onSearch,
  t,
}) {
  const [searchOpen, setSearchOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("all");
  function handleSearchClick() {
    setSearchOpen(!searchOpen);
  }

  function handleSelect(value) {
    if (value === "all") {
      onAllBlogsClick();
      setSelectedCategory("all");
    } else {
      onCategoryClick(value);
    }
    setSelectedCategory(value);
  }
  const router = useRouter();
  const [lang, setLang] = useState(router.locale);
  useEffect(() => {
    setLang(router.locale);
  }, [router.locale]);

  return (
    <div className="w-full z-10 h-16 mb-10 mt-2 bg-[#E6E6E9] bg-opacity-95 rounded-[10px]">
      <div className="flex items-center justify-between h-full">
        <ul
          className={`hidden lg:flex lg:flex-row justify-center align-middle font-medium ${
            lang == "ar" ? "mr-10" : "ml-10"
          } lg:gap-8`}
        >
          <li key={"0"}>
            <button
              onClick={() => {
                onAllBlogsClick();
                setSelectedCategory("all");
              }}
              className={`text-[#010140] selection:border h-full ${
                selectedCategory == "all" ? "rounded-lg" : ""
              } text-[#010140]`}
            >
              {t("allBlogs")}
            </button>
            <div
              className={`${
                selectedCategory === "all"
                  ? "bg-[#BE72F3]  w-50 h-[7px] rounded-t-full mx-auto mb-[19px] opacity-100 duration-300 ease-in-out"
                  : "bg-transparent opacity-0 duration-300 ease-in-out"
              }`}
            ></div>
          </li>

          {/* Rendering Categories */}

          {categories?.map(
            (category) =>
              // if the category.relatedBlogs is 0 then don't render it
              category?.relatedBlogs > 0 && (
                <Link
                  href={{
                    pathname: "/blogs",
                    query: { categoryName: category?._id },
                  }}
                >
                  <li key={category?._id}>
                    <button
                      onClick={() => {
                        // onCategoryClick(category?._id);
                        setSelectedCategory(category?._id);
                      }}
                      className={` text-[#010140]  h-full`}
                    >
                      <span>{category[lang]}</span>
                      &nbsp;
                      <span className="text-[#951B81] text-[18px] leading-3 ">
                        ({category?.relatedBlogs})
                      </span>
                      &nbsp;
                    </button>
                    <div
                      className={`${
                        selectedCategory === category._id
                          ? "bg-[#BE72F3]  w-50 h-[7px] rounded-t-full mx-auto mb-[19px] opacity-100 duration-300 ease-in-out"
                          : "bg-transparent opacity-0 duration-300 ease-in-out"
                      }`}
                    ></div>
                  </li>
                </Link>
              )
          )}
        </ul>

        {/* Search Section */}
        <div className="flex flex-row justify-between w-full lg:w-auto">
          <div className="block lg:hidden align-middle my-auto">
            <select
              className="bg-gray-200 rounded-md p-2 text-[#010140] active:border-none max-w-[120px] ring-transparent"
              onChange={(e) => handleSelect(e.target.value)}
            >
              <option value="" disabled default>
                Categories
              </option>
              <option value="all" onClick={onAllBlogsClick}>
                {t("allBlogs")}
              </option>
              {categories?.map((category) => (
                <option key={category._id} value={category._id}>
                  {category[lang]} ({category?.relatedBlogs})
                </option>
              ))}
            </select>
          </div>
          <div
            className={`cursor-pointer z-10 flex overflow-hidden justify-start ${
              lang == "ar" ? "ml-5" : "mr-5"
            }   navSearchInput h-fit items-center relative`}
          >
            <button
              className={`min-w-[24px] h-[45px] flex justify-center ${
                lang == "ar" ? "ml-2" : "mr-2"
              } `}
            >
              <Search className="w-[64] h-[64px] object-cover absolute -top-2" />
            </button>

            <span className="flex items-center border-b-[1px] border-[#010140] border-opacity-20">
              <input
                type="search"
                onChange={(e) => onSearch(e.target.value)}
                name=""
                id=""
                className="h-5 w-full border-none text-[10px]  outline-none flex items-center bg-transparent"
                placeholder={t("search")}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
